import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange?: (category: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  const location = useLocation();

  const handleClick = (catId: string) => {
    if (onCategoryChange) {
      onCategoryChange(catId);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-1.5 px-1 py-1 min-w-max">
        {categories.map((cat) => {
          const isActive = activeCategory === cat.id;
          if (onCategoryChange) {
            return (
              <button
                key={cat.id}
                onClick={() => handleClick(cat.id)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'bg-primary-500 text-background-50 font-medium'
                    : 'bg-background-100 text-foreground-400 hover:text-foreground-700 hover:bg-background-200/60 border border-background-200/40'
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </button>
            );
          }
          return (
            <Link
              key={cat.id}
              to={cat.id === 'all' ? '/' : `/category/${cat.id}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isActive
                  ? 'bg-primary-500 text-background-50 font-medium'
                  : 'bg-background-100 text-foreground-400 hover:text-foreground-700 hover:bg-background-200/60 border border-background-200/40'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
}